export const container = {
  tabActivity: 'Actividad',
  tabAppointments: 'Viajes',
}

export const activity = {
  noActivitiesTitle: '¡Todavía no hay actividad para mostrar!',
  noActivitiesSubtitle: 'En esta pestaña verás la actividad que realices en Space Guru. ¿Qué esperás para comenzar?',
}

export const appointments = {
  actions: {
    eventSuccessfullyCanceled: 'Evento cancelado con éxito',
  },
  upcomingAppointments: 'Pendientes',
  scheduleAppointment: 'Programar retiro',
  noUpcomingAppointments: 'No tenés transacciones pendientes',
  previousAppointments: 'Anteriores',
  noPreviousAppointments: 'No tenés transacciones anteriores',
  pickup: 'Pickup',
  delivery: 'Delivery',
  appointmentFirstLineMobile: 'a las', //Pickup a las 13:00
  appointmentFirstLine: 'el', //Pickup el 23 de Febrero 13:00
  viewDetailsButton: 'Ver Detalles',
  cancelButton: 'Cancelar',
  noAppointmentsTitle: '¡Todavía no hay retiros para mostrar!!',
  noAppointmentsSubtitle: 'Cuando programes un retiro de algún ítem de tu domicilio, lo verás en esta pestaña. ¿Qué esperás para probar?',
}

export const cancelAppointmentDialog = {
  areYouSure: '¿Seguro que desea cancelar el viaje?',
  chargeForCanceling: 'No hay problema. Puedes cancelar sin costo hasta 1 hora antes del mismo.',
  cancelButton: 'Sí, cancelar',
  rescheduleButton: 'Cambiar fecha y hora',
  closeButton: 'No, volver atrás'
}

export const viewAppointmentDialog = {
  when: 'Cuándo',
  where: 'Dónde',
  cancelButton: 'Cancelar evento',
  rescheduleButton: 'Cambiar fecha y hora',
  closeButton: 'Volver Atrás'
}



// WEBPACK FOOTER //
// ./src/sections/activity/text.js